import { Outlet, useOutletContext } from "react-router-dom";

import { FlowDndProvider } from "src/flowsOverview/v2/FlowDndProvider";
import { useIsSidebarLayout } from "src/hooks/useIsSidebarLayout";
import { DashboardContent } from "src/layout/DashboardContent";
import { LayoutHeader } from "src/layout/Header";
import { MainSideBar } from "src/mainPage/MainSideBar";
import { DashboardPageParams } from "src/router/urls";
import { useParamsDecode } from "src/utils/useParamsDecode";

export const MainPageDashboard: React.FC = () => {
  const context = useOutletContext();
  const isSideBarEnabled = useIsSidebarLayout();
  const { wsId } = useParamsDecode<DashboardPageParams>();

  return (
    <FlowDndProvider workspaceId={wsId}>
      <DashboardContent
        Header={!isSideBarEnabled && <LayoutHeader border />}
        sidebar={isSideBarEnabled && <MainSideBar />}
        removePadding
      >
        <Outlet context={context} />
      </DashboardContent>
    </FlowDndProvider>
  );
};
